import * as React from 'react';

function SvgSetPointS2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="setPointS2_svg__Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 72 72"
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {'.setPointS2_svg__st0{font-family:&apos;Lucida Console&apos;}'}
      </style>
      <text
        transform="translate(37.983 16.748)"
        className="setPointS2_svg__st0"
        fontSize={22}
      >
        {'S1'}
      </text>
      <text
        transform="matrix(1.0398 0 0 1 3 68.91)"
        className="setPointS2_svg__st0"
        fontSize={56}
      >
        {'S2'}
      </text>
      <path
        d="M29.5 9.2s-2.9 0-6.6.1c-3.6 0-6.5 2.4-6.5 5.3s.1 5.2.1 5.2"
        fill="none"
        strokeWidth={3.061}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path className="setPointS2_svg__st4" d="M28.2 4.6l7.9 4.5-7.9 4.7z" />
    </svg>
  );
}

export default SvgSetPointS2;
